import scrollIntoView from 'scroll-into-view-if-needed'

function scroll (el) {
  setTimeout(function () {
    scrollIntoView(el, {
      scrollMode: 'if-needed',
      block: 'nearest',
      inline: 'nearest'
    })
    window.scrollTo(0, 0)
  }, 300)
}

/* istanbul ignore next */
export default {
  bind: function (el) {
    el.addEventListener('focusin', (e) => {
      e.preventDefault()
      scroll(el)
    })

    el.addEventListener('focus', (e) => {
      e.preventDefault()
      scroll(el)
    })
  },

  unbind: function (el, binding, vNode) {
    // Remove Event Listeners
    el.addEventListener('focusin', (e) => {
      e.preventDefault()
      scroll(el)
    })
    el.removeEventListener('focus', (e) => {
      e.preventDefault()
      scroll(el)
    })
  }
}
